import * as React from 'react';
import { EmailOTP } from '@repo/ui-web';
import { StateToggle } from '../../components/StateToggle';

const states = ['default', 'error', 'success', 'disabled'] as const;
const backLinkModes = ['shown', 'hidden'] as const;

type ShowcaseState = (typeof states)[number];
type BackLinkMode = (typeof backLinkModes)[number];

export function EmailOTPShowcase() {
  const [state, setState] = React.useState<ShowcaseState>('default');
  const [backLinkMode, setBackLinkMode] = React.useState<BackLinkMode>('shown');
  const [value, setValue] = React.useState('');
  const [completedValue, setCompletedValue] = React.useState('');

  const showSuccess = state === 'success' || (state === 'default' && completedValue.length > 0);

  return (
    <div className="space-y-4">
      <StateToggle options={states} value={state} onChange={setState} label="State" />
      <StateToggle
        options={backLinkModes}
        value={backLinkMode}
        onChange={setBackLinkMode}
        label="Back Link"
      />

      <EmailOTP
        title="Check your email"
        subtitle="Enter the verification code sent to you."
        value={value}
        onChange={(nextValue) => {
          setValue(nextValue);
          if (nextValue.length < 6) {
            setCompletedValue('');
          }
        }}
        onComplete={setCompletedValue}
        disabled={state === 'disabled'}
        helperText={state === 'default' ? 'Code expires in 10 minutes.' : undefined}
        errorText={state === 'error' ? 'The code is invalid. Try again.' : undefined}
        successText={showSuccess ? 'Code accepted.' : undefined}
        resendLabel="Resend code"
        onResend={() => setCompletedValue('')}
        resendHint="30s"
        resendDisabled
        backLabel={backLinkMode === 'shown' ? 'Back to sign in' : undefined}
        onBack={backLinkMode === 'shown' ? (() => setCompletedValue('')) : undefined}
        otpAriaLabel="Verification code"
        pasteButtonLabel="Paste verification code"
        getClipboardText={() => '135790'}
      />

      <p className="text-xs text-muted-foreground">Value: {value || 'empty'}</p>
      <p className="text-xs text-muted-foreground">Completed: {completedValue || 'none'}</p>
    </div>
  );
}
